<template>
    <div>
        <my-upload field="img"
				@crop-success="cropSuccess"
				:langType="'pt-br'"
				v-model="show"
				:width="400"
				:height="400"
				:noSquare="true"
				:noCircle="false"
				:url="''"
				img-format="png"></my-upload>

        <form @submit.prevent="validateBeforeSubmit">
			<div class=" form-group row">
				<div class="col-md-12 text-center" style="margin-bottom: 4px">
					<img class="foto-perfil" v-if="form.foto != '' && form.foto != null" :src="imgDataUrl" />
					<fa-icon icon="user-circle" style="font-size: 5.5em" v-show="form.foto == '' || form.foto == null" />
				</div>
				<div class="col-md-12 text-center">
					<button type="button" @click="show = true" class="btn btn-success btn-sm"><fa-icon icon="camera" /> Inserir Foto</button>
					<button type="button" v-if="form.foto != '' && form.foto != null" @click="form.foto = ''" class="btn btn-danger btn-sm"><fa-icon icon="times" /> Excluir Foto</button>
				</div>

			</div>

            <div v-if="!perfil" class="form-group row">
                <label for="staticEmail" class="col-sm-2 col-form-label col-form-label-sm">Perfil:</label>
                <div class="col-sm-10">

					<select v-model="form.id_perfil"
							autocomplete="off"
							class="form-control form-control-sm"
							name="perfil"
							@change="clickAddPerfil(form.id_perfil)"
							:class="{'is-invalid' : errors.has('perfil')}"   >
						<option value="">Escolha</option>
						<option v-for="item in perfis" :key="item.id" :value="item.id">{{item.descricao}}</option>
					</select>
					<span  class="invalid-feedback" v-show="errors.has('perfil')">{{ errors.first('perfil') }}</span>

					<div>
						<button class="btn btn-sm btn-outline-primary"
								type="button"
								@click="form.perfis.splice(index, 1)"
								style="margin-right:5px; margin-bottom:5px; margin-top:5px"
								v-for="(item, index) in form.perfis" :key="item.id">
							{{item.descricao}} <fa-icon icon="times"></fa-icon>
						</button>
					</div>
                </div>
            </div>
            <div class="form-group row">
                <label for="staticEmail" class="col-sm-2 col-form-label col-form-label-sm">*Nome:</label>
                <div class="col-sm-10">
                    <input type="text"
                            name="nome"
                            v-validate="'required'"
                            autocomplete="off"
                            :class="{'is-invalid' : errors.has('nome')}"
                            v-model.trim="form.nome"
                            class="form-control form-control-sm">
                    <span  class="invalid-feedback" v-show="errors.has('nome')">{{ errors.first('nome') }}</span>
                </div>
            </div>
            <div class="form-group row">
                <label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">*E-mail:</label>
                <div class="col-sm-10">
                    <input type="text"
                            name="login"
                            autocomplete="off"
                            v-validate="'required'"
                            :class="{'is-invalid' : errors.has('login')}"
                            v-model.trim="form.login"
                            class="form-control form-control-sm">
                    <span  class="invalid-feedback" v-show="errors.has('login')">{{ errors.first('login') }}</span>
                </div>
            </div>
            <div class="form-group row">
                <label for="staticEmail" class="col-sm-2 col-form-label col-form-label-sm">*Celular:</label>
                <div class="col-sm-6">
                    <input type="text"
                            name="celular"
                            v-validate="'required'"
                            autocomplete="off"
                            :class="{'is-invalid' : errors.has('celular')}"
                            v-model.trim="form.celular"
							v-mask-phone.br
                            class="form-control form-control-sm">
                    <span  class="invalid-feedback" v-show="errors.has('celular')">{{ errors.first('celular') }}</span>
                </div>
            </div>
            <div class="form-group row">
                <label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">*Senha:</label>
                <div class="col-sm-8">
                    <input type="password"
                            name="senha"
                            autocomplete="off"
                            v-validate="requiredPass"
                            :class="{'is-invalid' : errors.has('senha')}"
                            v-model.trim.lazy="form.senha"
                            class="form-control form-control-sm" />

                    <small v-if="form.id != 0" class="text-info">Deixe em branco para manter a mesma senha.</small>
                    <span class="invalid-feedback" v-show="errors.has('senha')">{{ errors.first('senha') }}</span>

                </div>
            </div>
            <div v-if="_getPrivilegio(21) && !perfil" class="form-group row">
                <label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm"></label>
                <div class="col-sm-6">

                    <toggle-button
                                v-model.trim="form.ativo"
                                :width="110"
                                :height="30"
                                :sync="true"
                                :value="form.ativo"
                                :labels="{checked: 'ATIVO', unchecked: 'DESATIVADO'}"
                                :color="{checked: '#28a745', unchecked: '#dc3545'}"/>
                </div>
            </div>

            <hr />

            <div class="row">
                <div class="col-sm-12 text-right">
                    <small class="float-left text-info"><fa-icon icon="info-circle" transform="left-3" />Campos com * são obrigatórios.</small>
                    <button class="btn btn-success btn-sm">
                        <fa-icon icon="check" transform="left-3" /> SALVAR
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import myUpload from "vue-image-crop-upload"
import { mapState } from 'vuex'
import _ from 'lodash'
import axios from '../../../routers/axios';
export default {
	components: {
		myUpload
	},

	props: {
		perfil: {
			type: Boolean,
			required: false
		},
		perfis: {
			type: Array,
			required: false,
			default: () => [],
		}
	},

	data() {
		return {
			show: false,
			requiredPass: "required",
			tiposServicos: [],
			imgDataUrl: "",
			form: {
				id: 0,
				nome: "",
				login: "",
				senha: "",
				id_perfil: "",
				ativo: true,
				foto: "",
				celular: "",
				perfis: []
			}
		};
	},

	mounted() {
	},

	computed: {
		...mapState({
			config: state => state.sessao.config,
		}),
	},

	methods: {
		carregaUserPerfil(idUsuario) {
			axios.get(this._getUrl(`api/login/${idUsuario}`)).then(response => {
				this.editar(response.data);
			});
		},

		clickAddPerfil(idPerfil) {
			if (idPerfil != "") {
				// recupera o perfil
				let perfil = _.find(this.perfis, o => {
					return o.id == idPerfil;
				});

				let tem = false;

				// verifica se existe já lista
				_.forEach(this.form.perfis, item => {
					if (item.id == perfil.id) {
						tem = true;
					}
				});

				// caso não exista, adiciona
				if (!tem) {
					this.form.perfis.push(perfil);
				}

				this.form.id_perfil = "";
			}
		},

		cropSuccess(imgDataUrl, field) {
			this.imgDataUrl = imgDataUrl;
			this.$notify.loadIn('Carregando foto');
			axios.post(this._getUrl("api/file"), { img: this.imgDataUrl }).then(response => {
				this.form.foto = response.data;
			});
		},

		editar(item) {
			// console.log(item, this.perfis);

			this.requiredPass = "";
			this.form.id = item.id;
			this.form.nome = item.nome;
			this.form.login = item.login;
			this.form.senha = item.senha;
			this.form.ativo = item.ativo;
			this.form.foto = item.foto;
			this.form.celular = item.celular
			this.form.perfis = item.perfis


			if (item.foto != "" || item.foto != null) {
				this.imgDataUrl = this.config.baseURL + "users/" + item.foto;
			}
		},

		validateBeforeSubmit() {
			this.form.id == 0 ? (this.requiredPass = "required") : (this.requiredPass = "")

			this.$validator.validateAll().then(result => {
				if (result) {
					this.salva();
				}
			});
		},

		salva() {
			var data = {
				id: this.form.id,
				nome: this.form.nome,
				login: this.form.login,
				senha: this.form.senha,
				ativo: this.form.ativo,
				foto: this.form.foto,
				celular: this.form.celular,
				perfis: this.form.perfis
			};

			this.$notify.loadIn('Salvando')

			if (this.form.id != 0) {
				axios.put(this._getUrl(`api/login/${this.form.id}`), data).then(response => {
					this.$emit("item-salvo", response.data)
					 // prop pra saber se tá importando o componente do meu "olá, [seu nome]"
					if (this.perfil) {
						this.$notify.show('success', 'Perfil atualizado.')
					}
				});
			} else {
				axios.post(this._getUrl("api/login"), data).then(response => {
					this.$emit("item-salvo", response.data);
					this.form.id = response.data.id;
				});
			}
		}
	}
};
</script>

<style>
.vue-image-crop-upload .vicp-wrap {
	width: 300px !important;
	height: 470px !important;
}

.vicp-crop-right {
	float: left !important;
}

a.vicp-operate-btn:hover {
	color: #fff !important;
	background-color: #5cb85c !important;
	border-color: #4cae4c !important;
	text-decoration: none;
}

a.vicp-operate-btn {
	color: #fff !important;
	background-color: #5cb85c;
	border-color: #4cae4c;
	text-decoration: none;
}

.vue-image-crop-upload
	.vicp-wrap
	.vicp-step2
	.vicp-crop
	.vicp-crop-right
	.vicp-preview
	.vicp-preview-item {
	margin-left: 78px;
}
</style>



// WEBPACK FOOTER //
// src/views/adm/usuario/cadastro.vue